// This transforms a 'nifs:person' to an 'nifs:compactPerson'
import { CompactPerson } from '../../../interfaces/compactPerson';
import { Person } from '../../../interfaces/person';

export default function (person: Person): CompactPerson {
  return {
    name: person.name,
    shirtName: person.shirtName,
    id: person.personInTeamId && person.id ? person.id : person.personId,
  };
}
